import { render } from "./HeaderInfoCardV2EditModal.vue?vue&type=template&id=10f17e82&scoped=true"
import script from "./HeaderInfoCardV2EditModal.vue?vue&type=script&lang=js"
export * from "./HeaderInfoCardV2EditModal.vue?vue&type=script&lang=js"

import "./HeaderInfoCardV2EditModal.vue?vue&type=style&index=0&id=10f17e82&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f17e82"]])

export default __exports__